var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-subheader',{staticClass:"display-2"},[_vm._v("Datos en Tiempo Real de Variadores")])],1)],1),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.table_header_real_time,"items":_vm.data,"items-per-page":5}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }